<script lang="ts">
	import { ButtonSize } from "@components/common/ButtonSize.js";
	import Formatted from "@components/common/Formatted.svelte";
	import Icon from "@components/common/Icon.svelte";
	import Link from "@components/common/Link.svelte";
	import { iconMap } from "@core/assets/icons/iconMap.js";
	import type { ContentType } from "@core/schema/ContentType.js";
	import type { ContentBlockComponentProps } from "./ContentBlockComponentProps.js";

	const { data }: ContentBlockComponentProps<ContentType.Button> = $props();
	const resolvedIcon = $derived(data.icon !== undefined ? iconMap[data.icon] : undefined);
</script>

<div class="container-8">
	<Link href={data.url} variant={data.variant} size={ButtonSize.Medium}>
		<span class="flex items-center gap-3">
			<Formatted text={data.text} />
			{#if resolvedIcon}
				<Icon icon={resolvedIcon} class="size-5" />
			{/if}
		</span>
	</Link>
</div>
